import React from "react";

/**
 * Tlačítko. `stav="nacita"` ukáže v tlačítku točítko a „Ukládám", `stav="hotovo"`
 * ho na chvíli přebarví zeleně s fajfkou „Uloženo" a pak se samo vrátí.
 */
export function Button({ variant = "primary", className = "", stav, children, ...props }) {
  const base = variant === "primary" ? "btn-primary" : "btn-ghost";
  const [hotovo, setHotovo] = React.useState(false);
  React.useEffect(() => {
    if (stav !== "hotovo") { setHotovo(false); return undefined; }
    setHotovo(true);
    const t = setTimeout(() => setHotovo(false), 1800);
    return () => clearTimeout(t);
  }, [stav]);
  const zobraz = stav === "nacita" ? "nacita" : hotovo ? "hotovo" : null;
  return (
    <button className={`${base} justify-center ${className}`} data-stav={zobraz || undefined} aria-live="polite" {...props}>
      {zobraz === "nacita" ? (
        <span key="n" className="vjezd"><Spinner /> Ukládám</span>
      ) : zobraz === "hotovo" ? (
        <span key="h" className="vjezd">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
            strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
          Uloženo
        </span>
      ) : children}
    </button>
  );
}

export function Field({ label, hint, error, className = "", inputProps, children, testid }) {
  return (
    <label className={`block ${className}`}>
      {label && <span className="label-up text-muted block mb-1.5">{label}</span>}
      {children || <input className="field" data-testid={testid} {...inputProps} />}
      {hint && !error && <span className="block mt-1 text-[11px] text-muted-2">{hint}</span>}
      {error && <span className="block mt-1 text-[11px] text-danger">{error}</span>}
    </label>
  );
}

/** Přepínač zap / vyp: oranžová dráha, jezdec s pružinou a fajfkou. */
export function Switch({ checked, onChange, testid, label, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      data-testid={testid}
      onClick={() => onChange(!checked)}
      className={`prepinac relative h-7 w-[46px] shrink-0 rounded-pill transition-colors duration-300 disabled:opacity-50 ${
        checked ? "bg-accent" : "bg-track"
      }`}
    >
      <span
        className="absolute top-0.5 left-0.5 h-6 w-6"
        style={{ transform: `translateX(${checked ? 18 : 0}px)`, transition: "transform .36s cubic-bezier(.3,1.3,.5,1)" }}
      >
        <span className="prepinac-knofl h-6 w-6 rounded-pill bg-white shadow-[0_1px_3px_rgba(20,22,26,.22)] flex items-center justify-center text-accent">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2"
            strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
            style={{ opacity: checked ? 1 : 0, transition: "opacity .25s ease" }}><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
        </span>
      </span>
    </button>
  );
}

export function Spinner({ className = "" }) {
  return (
    <span
      className={`inline-block h-4 w-4 rounded-full border-2 border-current border-t-transparent animate-spin ${className}`}
    />
  );
}

export function Avatar({ name = "", url, size = 34, className = "" }) {
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        style={{ width: size, height: size }}
        className={`rounded-icon object-cover ${className}`}
      />
    );
  }
  return (
    <span
      style={{ width: size, height: size, fontSize: size * 0.36 }}
      className={`rounded-icon bg-sidebar-3 text-ondark font-semibold inline-flex items-center justify-center shrink-0 ${className}`}
    >
      {initials || "?"}
    </span>
  );
}

export function RoleBadge({ role }) {
  const map = {
    OWNER: "bg-accent/10 text-accent",
    OBCHODNIK: "bg-success-bg text-success",
    TECHNIK: "bg-[#eef0f3] text-sec",
  };
  const label = { OWNER: "Majitel", OBCHODNIK: "Obchodník", TECHNIK: "Technik" }[role] || role;
  return (
    <span className={`label-up px-2 py-1 rounded-chip ${map[role] || "bg-line text-sec"}`}>
      {label}
    </span>
  );
}
